import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	settings: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreActions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	more: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreActionsTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	settingsGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	settings: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-rows.actions-cell.settings',
		defaultMessage: 'Project settings',
		description: 'Dropdown menu item. Goes to Project settings page',
	},
	moreActions: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-rows.actions-cell.more-actions',
		defaultMessage: 'More actions for {name}',
		description: 'Button label. Button opens dropdown',
	},
	more: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-rows.actions-cell.more',
		defaultMessage: 'More',
		description: 'Button label. Button opens dropdown',
	},
	moreActionsTooltip: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-rows.actions-cell.more-actions-tooltip',
		defaultMessage: 'More actions',
		description: 'Tooltip for the more actions meatball menu button',
	},
	settingsGalaxia: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-rows.actions-cell.settings-galaxia',
		defaultMessage: 'Space settings',
		description: 'Dropdown menu item. Goes to Project settings page',
	},
});
export default messages;
